export const WebComponentTags = {
  AiListConfigurators: 'ai-list-configurators',
  AiVirtualAgentConfigurator: 'ai-virtual-agent-configurator',
  AiWidgetActiveCalls: 'ai-widget-active-calls',
  AiWidgetLiveVirtualAgents: 'ai-widget-live-virtual-agents',
} as const

export type WebComponentTag = (typeof WebComponentTags)[keyof typeof WebComponentTags]
